import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { authenticationService } from "services/authentication.service";
import { alertService } from 'components/Varios/alert_service'
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import Cargando from 'components/Varios/Cargando'
import { ObtenerAniosHistorialConsultor, ObtenerHistorialConsultor } from './FunctionsProyectosInstitucionales'
import TablaHistorialProyectosInstitucionalesConsultor from "./TablaHistorialProyectosInstitucionalesConsultor"
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';
import { GetDocumentVistaPrevia } from 'helpers/files';
import Swal from 'sweetalert2';

type StateHistorialDetalle = {
    aniosDisponibles: number[],
    tabladetalle: Array<any>,
    loading: boolean,
    error: boolean,
    anioSeleccionado: number
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

export default function ProyectosInstitucionalesConsultor() {
    const defaultStateHistorialDetalle: StateHistorialDetalle = {
        aniosDisponibles: [],
        tabladetalle: [],
        loading: false,
        error: false,
        anioSeleccionado: -1
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const [getstateHistorialDetalle, setstateHistorialDetalle] = useState<StateHistorialDetalle>(defaultStateHistorialDetalle);
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia);

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    function handleErrorInformacion(message?: string) {
        const mensaje = message ?? "Ha ocurrido un evento inesperado al intentar obtener información"
        alertService.error(mensaje)
    }

    async function ObtenerInformacionAniosHistorial() {
        setstateHistorialDetalle({ ...getstateHistorialDetalle, loading: true })
        const respuesta = await ObtenerAniosHistorialConsultor();
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial");
            setstateHistorialDetalle({ ...getstateHistorialDetalle, loading: false, error: true })
        }
        else {
            const anioSeleccionado = respuesta.dataResponse[0]
            setstateHistorialDetalle({ ...getstateHistorialDetalle, loading: false, aniosDisponibles: respuesta.dataResponse, anioSeleccionado })
        }
    }

    async function ConsultarHistorial(stateHistorial: StateHistorialDetalle) {
        setstateHistorialDetalle({ ...stateHistorial, loading: true })
        const anio = stateHistorial.anioSeleccionado
        const respuesta = await ObtenerHistorialConsultor(anio)
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial")
            setstateHistorialDetalle({ ...stateHistorial, error: true, loading: false })
        }
        else {
            setstateHistorialDetalle({ ...stateHistorial, tabladetalle: respuesta.dataResponse, loading: false })
        }
    }

    const onClickVerDoc = useCallback(async (referencia: string) => {
        setstateModalVP({ ...stateModalVP, loading: true })
        const datosUsuario: UserData = authenticationService.currentUserValue;
        const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
        setstateModalVP({ ...stateModalVP, loading: false, url })
    }, [stateModalVP])

    const GetHistorialByAnio = useCallback(async (anio: number) => {
        setstateHistorialDetalle({ ...getstateHistorialDetalle, loading: true })
        const respuesta = await ObtenerHistorialConsultor(anio)

        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial")
            setstateHistorialDetalle({ ...getstateHistorialDetalle, error: true, loading: false })
        }
        else {
            setstateHistorialDetalle({ ...getstateHistorialDetalle, tabladetalle: respuesta.dataResponse, loading: false, anioSeleccionado: anio })
        }
    }, [getstateHistorialDetalle])

    useEffect(() => {
        ObtenerInformacionAniosHistorial();
    }, [])

    useEffect(() => {
        if (getstateHistorialDetalle.aniosDisponibles.length > 0) {
            ConsultarHistorial(getstateHistorialDetalle);
        }
    }, [getstateHistorialDetalle.aniosDisponibles])

    const TablaHistorialSolicitudesProyectosInstitucionales = useMemo(() => {
        if (getstateHistorialDetalle.loading) {
            return <Cargando />
        }
        else if (getstateHistorialDetalle.error) {
            return <div>No ha sido posible obtener información</div>
        }
        else if (!getstateHistorialDetalle.error && (getstateHistorialDetalle.aniosDisponibles.length === 0 && getstateHistorialDetalle.tabladetalle.length === 0)) {
            return <div className="row-no-margin">No hay historial de solicitudes por mostrar</div>
        }
        else if (!getstateHistorialDetalle.loading && getstateHistorialDetalle.tabladetalle.length > 0) {
            return (
                <TablaHistorialProyectosInstitucionalesConsultor
                    anioSeleccionado={getstateHistorialDetalle.anioSeleccionado}
                    dataFilas={getstateHistorialDetalle.tabladetalle}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onChangeAnio={(anio: number) => GetHistorialByAnio(anio)}
                />
            )
        }
    }, [getstateHistorialDetalle]);

    return (
        <div className='content'>
            <div className="titulo_seccion">
                Consulta de designaciones de responsabilidad en proyectos institucionales
            </div>

            {TablaHistorialSolicitudesProyectosInstitucionales}

            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />
        </div>
    )
}